
const setInspection = (state, inspection) => {
  state.inspection = inspection;
};

const setInspectionError = (state, error) => {
  state.inspectionError = error;
};

const setInspections = (state, inspection) => {
  state.inspections = inspection.folders || [];
};

const setReportHasSummary = (state, reportId) => {
  state.inspection.reports = state.inspection.reports.map(report => {
    if (report.id === reportId) {
      return { ...report, hasSummary: true };
    }
    return report;
  });
};

export default {
  setInspection,
  setInspectionError,
  setInspections,
  setReportHasSummary,
};
